import { Button } from '@/components/button';
import i18n from '@/locales/init';

export interface PaySuccessProps {
  confirm?: () => void;
  confirmText?: string;
}
export const PaySuccess = (props: PaySuccessProps) => {
  const { confirmText = i18n.t('完成'), confirm } = props;
  return <div className='flex flex-col items-center gap-[32px] px-[24px]'>
    <div className='text-[24px] text-[#000000] font-bold'>{i18n.t('购买完成')}</div>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM21.6754 30.3189L14.8114 23.3726L10.2857 27.696C13.5771 29.4686 18.1886 32.7017 22.1383 37.7143C24.9291 32.4686 33.5314 21.7371 37.7143 20.7771C37.0389 18.072 36.6583 12.9943 37.7143 10.2857C29.136 15.9429 21.6754 30.3189 21.6754 30.3189Z" fill="#029B00"/>
    </svg>
    <div className='text-[14px] text-[#00000099] text-center'>{i18n.t('恭喜你已经支付成功，你的AI雅思高分之旅正式启航！')}</div>
    <Button className='w-full' variant={'confirm'} size={'lgg'} onClick={confirm}>{confirmText}</Button>
  </div>;
};
